import {
  getWechatInfoByOpenidAndUnionId
} from '@/api/home'
import { getUserInfo,setToken } from '../../utils/storage'

const state = {
  userName: '',
  queryParams: {}
}
const mutations = {
  SET_USER_NAME(state, name) {
    state.userName = name
  },
  SET_QUERY_PARAMS(state, queryParams) {
    state.queryParams = queryParams
  },
  SET_TOKEN(state, token) {
    state.token = token
    setToken(token)
  },
}
const actions = {
  // 设置name
  setUserName({ commit }, name) {
    commit('SET_USER_NAME', name)
  },
}
export default {
  state,
  mutations,
  actions
}
